import React from 'react';
import PropTypes from 'prop-types';
import { join } from 'lodash';
import Yup from 'yup';
import { Field } from 'formik';
import MenuItem from '@material-ui/core/MenuItem';
import {
  DropdownWrapper,
  GridContainer,
  GridItem,
  TextFieldWrapper,
} from '../../common';
import { DIET_ROUTE, DIET_TYPE } from '../../../lib/dataLayer';

const FREQUENCY = 'frequency';
const ROUTE = 'routeId';
const TYPE = 'typeId';
const NAME = 'name';
const NOTES = 'notes';

function Diet({ paths }) {
  return (
    <GridContainer alignItems="baseline" spacing={24}>
      <GridItem lg={3} xs={12}>
        <Field
          component={DropdownWrapper}
          id={TYPE}
          label="Type"
          name={join([...paths, TYPE], '.')}
          paths={[...paths, TYPE]}
        >
          <MenuItem value={DIET_TYPE.REGULAR.value}>
            {DIET_TYPE.REGULAR.label}
          </MenuItem>
          <MenuItem value={DIET_TYPE.FORMULA.value}>
            {DIET_TYPE.FORMULA.label}
          </MenuItem>
          <MenuItem value={DIET_TYPE.PUREED.value}>
            {DIET_TYPE.PUREED.label}
          </MenuItem>
          <MenuItem value={DIET_TYPE.TPN.value}>{DIET_TYPE.TPN.label}</MenuItem>
          <MenuItem value={DIET_TYPE.OTHER.value}>
            {DIET_TYPE.OTHER.label}
          </MenuItem>
        </Field>
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={DropdownWrapper}
          id={ROUTE}
          label="Route"
          name={join([...paths, ROUTE], '.')}
          paths={[...paths, ROUTE]}
        >
          <MenuItem value={DIET_ROUTE.ORAL.value}>
            {DIET_ROUTE.ORAL.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.IV.value}>{DIET_ROUTE.IV.label}</MenuItem>
          <MenuItem value={DIET_ROUTE.G_TUBE.value}>
            {DIET_ROUTE.G_TUBE.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.J_TUBE.value}>
            {DIET_ROUTE.J_TUBE.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.GJ_TUBE.value}>
            {DIET_ROUTE.GJ_TUBE.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.NG_TUBE.value}>
            {DIET_ROUTE.NG_TUBE.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.NJ_TUBE.value}>
            {DIET_ROUTE.NJ_TUBE.label}
          </MenuItem>
          <MenuItem value={DIET_ROUTE.OTHER.value}>
            {DIET_ROUTE.OTHER.label}
          </MenuItem>
        </Field>
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={FREQUENCY}
          label="Frequency"
          name={join([...paths, FREQUENCY], '.')}
          paths={[...paths, FREQUENCY]}
        />
      </GridItem>
      <GridItem lg={3} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NAME}
          label="Name of Formula"
          name={join([...paths, NAME], '.')}
          paths={[...paths, NAME]}
        />
      </GridItem>
      <GridItem lg={12} xs={12}>
        <Field
          component={TextFieldWrapper}
          id={NOTES}
          label="Notes"
          multiline
          name={join([...paths, NOTES], '.')}
          paths={[...paths, NOTES]}
        />
      </GridItem>
    </GridContainer>
  );
}

Diet.propTypes = {
  paths: PropTypes.array,
};

Diet.defaultProps = {
  paths: [],
};

export default Diet;

export const getDietValidation = () => ({
  [FREQUENCY]: Yup.string(),
  [NAME]: Yup.string(),
  [NOTES]: Yup.string(),
  [ROUTE]: Yup.number(),
  [TYPE]: Yup.number(),
});



// WEBPACK FOOTER //
// ./src/modules/DietPage/components/Diet.js